import React, { useEffect, useMemo, useRef } from 'react';
var NotificationTabConfigItem = /** @class */ (function () {
    function NotificationTabConfigItem() {
    }
    return NotificationTabConfigItem;
}());
export { NotificationTabConfigItem };
var NotificationTabConfig = /** @class */ (function () {
    function NotificationTabConfig() {
    }
    return NotificationTabConfig;
}());
export { NotificationTabConfig };
var VeltNotificationsPanel = function (props) {
    var darkMode = props.darkMode, onNotificationClick = props.onNotificationClick, shadowDom = props.shadowDom, tabConfig = props.tabConfig, variant = props.variant, readNotificationsOnForYouTab = props.readNotificationsOnForYouTab, panelOpenMode = props.panelOpenMode, settings = props.settings, selfNotifications = props.selfNotifications, pageSize = props.pageSize, settingsLayout = props.settingsLayout, enableSettingsAtOrganizationLevel = props.enableSettingsAtOrganizationLevel, defaultCondition = props.defaultCondition, enableCrossOrganization = props.enableCrossOrganization;
    var ref = useRef();
    var onNotificationClickRef = useRef(onNotificationClick);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onNotificationClickRef.current = onNotificationClick;
    }, [onNotificationClick]);
    useEffect(function () {
        var element;
        var handleNotificationClick = function (event) {
            if (onNotificationClickRef.current) {
                onNotificationClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element === null || element === void 0 ? void 0 : element.addEventListener('onNotificationClick', handleNotificationClick);
            }
        }
        return function () {
            if (element) {
                element === null || element === void 0 ? void 0 : element.removeEventListener('onNotificationClick', handleNotificationClick);
            }
        };
    }, []);
    var enableCrossOrganizationValue = useMemo(function () {
        try {
            if (typeof enableCrossOrganization === 'boolean') {
                return enableCrossOrganization ? 'true' : 'false';
            }
            else if (typeof enableCrossOrganization === 'string') {
                return enableCrossOrganization;
            }
            else if (typeof enableCrossOrganization === 'object') {
                return JSON.stringify(enableCrossOrganization);
            }
            return undefined;
        }
        catch (error) {
            return undefined;
        }
    }, [enableCrossOrganization]);
    return (React.createElement("velt-notifications-panel", { ref: ref, variant: variant, "tab-config": JSON.stringify(tabConfig), "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined, settings: [true, false].includes(settings) ? (settings ? 'true' : 'false') : undefined, "self-notifications": [true, false].includes(selfNotifications) ? (selfNotifications ? 'true' : 'false') : undefined, "read-notifications-on-for-you-tab": [true, false].includes(readNotificationsOnForYouTab) ? (readNotificationsOnForYouTab ? 'true' : 'false') : undefined, "panel-open-mode": panelOpenMode, "page-size": (pageSize && pageSize > 0) ? pageSize + '' : undefined, "settings-layout": settingsLayout, "enable-settings-at-organization-level": [true, false].includes(enableSettingsAtOrganizationLevel) ? (enableSettingsAtOrganizationLevel ? 'true' : 'false') : undefined, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined, "enable-cross-organization": enableCrossOrganizationValue }));
};
export default VeltNotificationsPanel;
